module.exports = __webpack_public_path__ + "static/media/press-tc-article@2x.5f069baf.jpg";